import Repository from './Repository';
const COURSE = '/courses';
export default {
  getAllCourses() {
    return Repository.get(`${COURSE}`);
  }
};
